import { createSelector } from '@reduxjs/toolkit';
import { selectConstructionTypeLabel } from './selectConstructionTypeLabel';
import { selectConstructionTypeOptions } from './selectConstructionTypeOptions';
import { selectHouseMaterial } from 'shared/selectors/jsonQuery';
import { EHouseMaterial } from '../../../../packages/api-models/common/json_query';

export const selectConstructionTypeFilter = createSelector(
  [selectConstructionTypeLabel, selectConstructionTypeOptions, selectHouseMaterial],
  (label, options, value) => ({
    label,
    options,
    value: value ? (value as EHouseMaterial[]) : [null],
  }),
);
